import * as React from 'react';
export const KHSvg = React.forwardRef(function KHSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 5V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0Zm14 9H2a2 2 0 0 1-2-2v-1h16v1a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M4 8h8v2H4V8Zm0-2h2v1H4V6Zm3 0h2v1H7V6Zm3 0h2v1h-2V6Z',
      }),
    ),
  );
});
KHSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KH = {
  category: 'flag',
  colorable: false,
  name: 'KH',
  svg: KHSvg,
};
